import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "../../components/common/AppNavbar";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Source+Serif+4:ital,wght@0,400;0,500;1,400&display=swap');

  .cyber-page {
    background: #FAFAF8;
    min-height: 100vh;
    font-family: 'Source Serif 4', Georgia, serif;
    color: #1C1C1C;
  }

  .cyber-hero-bar {
    background: linear-gradient(90deg, #7B0000 0%, #B80000 60%, #D32F2F 100%);
    height: 5px;
    width: 100%;
  }

  .cyber-header h2 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.3;
    color: #1C1C1C;
  }

  .cyber-badge-alert {
    background: #FFEBEE !important;
    color: #C62828 !important;
    border: 1px solid #EF9A9A;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 3px;
  }

  .cyber-badge-community {
    background: #FFF3E0 !important;
    color: #B84500 !important;
    border: 1px solid #F0A060;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 3px;
  }

  .cyber-dateline {
    font-size: 0.9rem;
    color: #888;
    letter-spacing: 0.5px;
    border-left: 3px solid #C62828;
    padding-left: 10px;
    margin-top: 8px;
    display: inline-block;
  }

  .cyber-divider {
    border: none;
    border-top: 1px solid #E8E0D0;
    margin: 28px 0;
  }

  .cyber-body p {
    font-size: 1.05rem;
    line-height: 1.85;
    color: #333;
    margin-bottom: 18px;
  }

  .cyber-section-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: #1C1C1C;
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 18px;
  }

  .cyber-section-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #C62828, #D32F2F);
    border-radius: 2px;
  }

  /* Red warning banner */
  .cyber-alert-banner {
    background: #FFEBEE;
    border: 1px solid #EF9A9A;
    border-left: 4px solid #C62828;
    border-radius: 6px;
    padding: 20px 24px;
    margin-bottom: 28px;
    display: flex;
    gap: 14px;
    align-items: flex-start;
  }

  .cyber-alert-banner .alert-icon {
    font-size: 1.6rem;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .cyber-alert-banner .alert-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1rem;
    font-weight: 700;
    color: #C62828;
    margin-bottom: 4px;
  }

  .cyber-alert-banner .alert-text {
    font-size: 0.95rem;
    color: #6B1A1A;
    line-height: 1.6;
    margin: 0;
  }

  /* Video */
  .cyber-video-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  }

  /* Cards */
  .cyber-card {
    border: 1px solid #E8E0D0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
    background: #fff !important;
  }

  .cyber-card .card-body { padding: 28px 32px; }

  .cyber-card h3, .cyber-card h4 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1C1C1C;
    margin-bottom: 14px;
  }

  .cyber-card h5 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1rem;
    font-weight: 600;
    color: #C62828;
    margin-bottom: 10px;
  }

  .cyber-card p {
    font-size: 0.97rem;
    line-height: 1.8;
    color: #444;
    margin-bottom: 10px;
  }

  /* How it operates — step list */
  .cyber-step-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .cyber-step-list li {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    padding: 12px 0;
    border-bottom: 1px solid #F5F0EA;
    font-size: 0.97rem;
    color: #333;
    line-height: 1.6;
  }

  .cyber-step-list li:last-child { border-bottom: none; }

  .cyber-step-icon {
    font-size: 1.1rem;
    flex-shrink: 0;
    margin-top: 1px;
  }

  /* Safety tips */
  .cyber-tips-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .cyber-tips-list li {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 11px 0;
    border-bottom: 1px solid #F5F0EA;
    font-size: 0.97rem;
    color: #333;
    line-height: 1.6;
  }

  .cyber-tips-list li:last-child { border-bottom: none; }

  .cyber-tip-check {
    background: #E8F5E9;
    color: #2E7D32;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
    flex-shrink: 0;
    margin-top: 1px;
  }

  /* Official warnings card */
  .cyber-warning-card {
    background: #FFF8F8 !important;
    border: 1px solid #EF9A9A !important;
    border-left: 4px solid #C62828 !important;
    border-radius: 8px !important;
  }

  .cyber-warning-card .card-body { padding: 28px 32px; }

  .cyber-warning-card h3 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #C62828;
    margin-bottom: 14px;
  }

  .cyber-warning-card ul {
    padding-left: 0;
    list-style: none;
    margin: 0;
  }

  .cyber-warning-card ul li {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 9px 0;
    border-bottom: 1px solid #FDDEDE;
    font-size: 0.97rem;
    color: #6B1A1A;
    line-height: 1.6;
  }

  .cyber-warning-card ul li:last-child { border-bottom: none; }

  /* CTA */
  .cyber-cta-card {
    background: linear-gradient(135deg, #1C1C1C 0%, #2E1A06 100%) !important;
    border: none !important;
    border-radius: 8px !important;
  }

  .cyber-cta-card .card-body { padding: 28px 32px; }

  .cyber-cta-card h3 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.25rem;
    color: #F0C040;
    margin-bottom: 14px;
  }

  .cyber-cta-card p {
    color: rgba(255,255,255,0.75);
    font-size: 0.97rem;
    line-height: 1.75;
    margin-bottom: 12px;
  }

  .cyber-cta-card .cta-highlight {
    color: #fff;
    font-weight: 600;
    font-style: italic;
    font-size: 1rem;
  }

  /* About */
  .cyber-about-card {
    background: #fff !important;
    border: 1px solid #E8E0D0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
  }

  .cyber-about-card .card-body { padding: 28px 32px; }

  .cyber-about-card h4 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.2rem;
    color: #1C1C1C;
    margin-bottom: 8px;
  }

  .cyber-about-card .about-link {
    color: #B84500;
    font-size: 0.88rem;
    font-weight: 600;
    text-decoration: none;
  }

  .cyber-about-card p {
    font-size: 0.95rem;
    line-height: 1.75;
    color: #555;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    .cyber-header h2 { font-size: 1.5rem; }
    .cyber-card .card-body,
    .cyber-warning-card .card-body,
    .cyber-cta-card .card-body,
    .cyber-about-card .card-body { padding: 20px; }
    .cyber-alert-banner { flex-direction: column; gap: 8px; }
  }
`;

const scamSteps = [
  {
    icon: "🎭",
    text:
      "Fraudsters impersonate Indian Consulate officials, police officers, or intelligence agents.",
  },
  {
    icon: "📋",
    text:
      "Victims are falsely told their identity, passport, OCI card, or phone number is linked to serious crimes in India.",
  },
  {
    icon: "📲",
    text:
      "Scammers request identity documents such as passports or OCI cards and ask victims to communicate via WhatsApp, Microsoft Teams, or video calls.",
  },
  {
    icon: "🎖️",
    text:
      "Criminals may appear on video wearing police uniforms and display fake government logos or fabricated legal documents to appear legitimate.",
  },
  {
    icon: "🔇",
    text:
      'Victims are pressured into secrecy and told they must "cooperate" to avoid arrest, deportation, or legal consequences.',
  },
  {
    icon: "🏦",
    text:
      'In some cases, scammers claim they will "protect" the victim by monitoring bank accounts — an attempt to gain access to financial information.',
  },
];

const safetyTips = [
  "Do not share personal, banking, passport, or OCI information with unsolicited callers.",
  "Do not engage in video calls claiming to be police or consulate officials.",
  "Hang up immediately and verify through official government websites or publicly listed phone numbers.",
  'Never transfer money or allow "monitoring" of bank accounts.',
  "Report incidents to local law enforcement, the FTC, banks, and the appropriate consulate.",
];

const officialWarnings = [
  "Government agencies do not conduct investigations via phone calls, WhatsApp, or video apps.",
  "Indian Police and Consulates do not demand personal or financial information electronically.",
  "No legitimate authority will threaten arrest, asset seizure, or deportation over phone or messaging platforms.",
];

const videoHighlights = [
  "Fake police video calls",
  "Psychological intimidation tactics",
  'The myth of "digital arrest"',
  "The importance of staying calm and verifying information",
];

function CybercrimeAlert() {
  return (
    <>
      <style>{styles}</style>
      <AppNavbar />

      <div className="cyber-page">
        <div className="cyber-hero-bar" />

        <div className="container py-5">
          {/* Header */}
          <div className="cyber-header mb-4">
            <div className="d-flex flex-wrap gap-2 mb-3">
              <span className="badge cyber-badge-alert">⚠ Community Alert</span>
              <span className="badge cyber-badge-community">
                Cybercrime Awareness
              </span>
            </div>
            <h2>
              Cybercriminals Impersonating Indian Police and Consulate Officials
              Target Senior Citizens Abroad
            </h2>
            <div className="cyber-dateline">
              Incident reported March 31, 2026 — Bharatabroad Community Member
            </div>
          </div>

          <hr className="cyber-divider" />

          {/* Alert Banner */}
          <div className="cyber-alert-banner">
            <div className="alert-icon">🚨</div>
            <div>
              <div className="alert-title">
                Please Share With Your Community
              </div>
              <p className="alert-text">
                Authorities are urging heightened vigilance following a rise in
                sophisticated cyber fraud schemes in which criminals pose as
                Indian Police, Indian Consulate, and intelligence officials to
                target senior citizens living overseas, particularly in the
                United States.
              </p>
            </div>
          </div>

          {/* Intro */}
          <div className="cyber-body mb-4">
            <p>
              In a recent incident reported on March 31, 2026, a senior U.S.
              resident received a phone call from an individual falsely claiming
              to represent the Indian Consulate. The caller alleged that the
              victim's U.S. phone number had been misused to obtain an Indian
              mobile number supposedly connected to criminal activity.
            </p>
            <p>
              The call appeared convincing. The scammer asked the victim to text
              a Delhi Police Headquarters number via WhatsApp only. A person in
              uniform responded on video with a headquarters logo on their
              contact picture, and the victim was transferred to a second
              individual. The scam quickly escalated — with the logo staying on
              screen throughout — accusing the victim of involvement in
              harassment, money laundering, and cryptocurrency-related offenses.
            </p>
          </div>

          {/* How It Operates */}
          <div className="card cyber-card mb-4">
            <div className="card-body">
              <h3>How the Scam Operates</h3>
              <p>
                According to reports from victims and warnings issued by Indian
                Consulates and Indian Police, these fraud schemes follow a
                consistent pattern:
              </p>
              <ul className="cyber-step-list">
                {scamSteps.map((step, i) => (
                  <li key={i}>
                    <span className="cyber-step-icon">{step.icon}</span>
                    <span>{step.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Close Call */}
          <div className="mb-4">
            <h3 className="cyber-section-title">
              A Close Call That Prevented Financial Loss
            </h3>
            <div className="cyber-body">
              <p>
                In the reported incident, the victim became suspicious after
                noticing inconsistencies and independently checking the official
                website of the Indian Consulate, where a public warning
                described the exact scam scenario.
              </p>
              <p>
                Upon realizing the deception, the victim immediately
                disconnected communications, blocked the perpetrators, contacted
                banks to secure accounts, and placed fraud alerts with credit
                bureaus. Authorities emphasize that{" "}
                <strong>
                  timely awareness and verification are often the key factors
                  that prevent financial loss.
                </strong>
              </p>
            </div>
          </div>

          {/* Official Warnings */}
          <div className="card cyber-warning-card mb-4">
            <div className="card-body">
              <h3>⚠ Official Advisory from Indian Authorities</h3>
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#6B1A1A",
                  marginBottom: "16px",
                }}
              >
                Indian Consulates and Indian Police departments have repeatedly
                issued public advisories clarifying that:
              </p>
              <ul>
                {officialWarnings.map((w, i) => (
                  <li key={i}>
                    <span
                      style={{
                        color: "#C62828",
                        flexShrink: 0,
                        marginTop: "2px",
                      }}
                    >
                      ✕
                    </span>
                    <span>{w}</span>
                  </li>
                ))}
              </ul>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#6B1A1A",
                  marginTop: "16px",
                  marginBottom: 0,
                  fontStyle: "italic",
                }}
              >
                These scams are designed to exploit trust, authority, and fear —
                especially among senior citizens who may be unfamiliar with
                modern cyber fraud tactics.
              </p>
            </div>
          </div>

          {/* Safety Tips */}
          <div className="card cyber-card mb-4">
            <div className="card-body">
              <h3>What Community Members Should Do</h3>
              <p>
                Community leaders and families are encouraged to share the
                following safety tips:
              </p>
              <ul className="cyber-tips-list">
                {safetyTips.map((tip, i) => (
                  <li key={i}>
                    <span className="cyber-tip-check">✓</span>
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Video */}
          <div className="mb-4">
            <h3 className="cyber-section-title">
              Watch: Official UP Police Awareness Film
            </h3>
            <div className="cyber-body">
              <p>
                Watch the official UP Police cyber crime awareness film,{" "}
                <em>Digital Arrest Scam</em>, which clearly highlights the
                tactics used by scammers:
              </p>
            </div>
            <div className="cyber-video-wrapper ratio ratio-16x9 mb-3">
              <iframe
                src="https://www.youtube.com/embed/Ew4CVvTcoVI"
                title="Digital Arrest Scam – UP Police Awareness Film"
                allowFullScreen
              />
            </div>
            <div className="card cyber-card">
              <div className="card-body py-3">
                <h5 className="mb-2">The film highlights:</h5>
                <ul
                  style={{
                    paddingLeft: "20px",
                    color: "#444",
                    fontSize: "0.95rem",
                    lineHeight: "1.8",
                    marginBottom: 0,
                  }}
                >
                  {videoHighlights.map((h, i) => (
                    <li key={i}>{h}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="card cyber-cta-card mb-4">
            <div className="card-body">
              <h3>A Call to Action</h3>
              <p>
                Cybercrime is evolving rapidly, and awareness remains the
                strongest defense. Community organizations, senior centers,
                families, and associations are urged to share this information
                widely to protect vulnerable individuals.
              </p>
              <p className="cta-highlight">
                If you or someone you know receives a call claiming to be from
                an Indian government agency — pause, verify, and report.
              </p>
              <p style={{ marginBottom: 0 }}>
                Staying informed can prevent emotional distress and significant
                financial harm.
              </p>
            </div>
          </div>

          {/* About Bharat Abroad */}
          <div className="card srk-about-card mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                {/* Left Image */}
                <div className="col-md-3 text-center mb-3 mb-md-0">
                  <img
                    src="https://ayg.s3.us-east-2.amazonaws.com/BA_whatsapp.png"
                    alt="Bharat Abroad"
                    className="img-fluid rounded"
                    style={{ height: "auto" }}
                  />
                </div>

                {/* Right Content */}
                <div className="col-md-9">
                  <h4>About Bharat Abroad</h4>

                  <p className="mb-2">
                    <a
                      href="https://chat.whatsapp.com/LNfGI3UFWbt69VeUbBoxLj"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="about-link"
                    >
                      www.bharatabroad.com
                    </a>{" "}
                    — Subscribe with us / Join our WhatsApp Community
                  </p>

                  <p className="mb-0">
                    Bharat Abroad is a community-focused initiative dedicated to
                    highlighting and strengthening Bharat's cultural and
                    spiritual presence across the global diaspora through
                    storytelling, event engagement, and collaboration with
                    nonresident Bharatiya organizations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CybercrimeAlert;
